import type { Screen } from "../../app/api/ApiClient";
import type { StateStore } from "../../app/state/StateStore";

import { ScreenMapper } from "./ScreenMapper";

type OtpScreen =
    Extract<Screen, { type: "otp" }>;

export class OtpScreenMapper
    implements ScreenMapper<OtpScreen> {

    public readonly type = "otp" as const;

    constructor(
        private readonly store: StateStore
    ) {}

    public apply(
        screen: OtpScreen
    ): void {

        const state =
            this.store.getState();

        this.store.replace({

            ...state,

            primaryScreen: {

                type: "otp",

                email: screen.email

            },

            isLoading: false

        });

    }

}